export let conditionalMapOptions; 
function getMapName() {
    if (window.location.pathname[window.location.pathname.length-1] != '/')
    {
        return window.location.pathname.split("/").pop().toLowerCase(); 
    }
    else {
        let url = window.location.pathname;
        url = url.substring(0, url.length - 1);
        return url.split("/").pop().toLowerCase(); 
    }

}

export async function importConditions(MapConfig) {
    let mapName = getMapName(); 
    
    conditionalMapOptions = MapConfig[mapName]; 

    return conditionalMapOptions;

}